module.exports = [
  { value: 'status_set', label: 'Status setzen'},
  { value: 'tag_add', label: 'Tag hinzufügen'},
  { value: 'tag_remove', label: 'Tag entfernen'},
  { value: 'url_set', label: 'URL zuweisen'},
  { value: 'poll_close', label: 'Absatz-Umfrage: Umfrage schliessen'},
  { value: 'ugc', label: 'UGC'},
];
